import { useState } from "react";

type FilterProps = {
    search?: string;
    position?: number;
    departments?: number[]
}

const useEmployeeFilter = () => {
    const [search, setSearch] = useState<string>("");
    const [position, setPosition] = useState<number>(NaN);
    const [departments, setDepartments] = useState<number[]>([]);

    const setEmployeeFilter = (filter: FilterProps) => {
        setSearch(filter.search as any);
        setDepartments(filter.departments as any);
        setPosition(filter.position as any)
    }

    return ({
        search, position, departments,
        setEmployeeFilter
    })
}

export default useEmployeeFilter;